import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toggleReset } from 'app/store/features/notificationsSlice';
import { deletePolicyByCache } from 'app/store/features/privacySlice';
import appService from 'app/services/appService';
import jwt_decode from 'jwt-decode';

const AppLogout = ({ children, cookie }) => {
  const withoutTemplate = useSelector(state => state.privacyPersisted.WithoutTemplate);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  let timer;
  const decodedToken = jwt_decode(cookie);
  const expirationTime = decodedToken.exp * 1000;

  const currentTime = new Date();
  const expiry = new Date(expirationTime);
  const remainingTime = Math.floor((expiry.getTime() - currentTime.getTime()) / (1000 * 60)); // Difference in minutes

  const time = remainingTime * 60000;

  // this function sets the timer that logs out the user after 10 secs
  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      // Clear any pending timer
      resetTimer();

      // Remove the event listener from the window
      window.removeEventListener('mousemove', resetTimer);

      // Logout user
      logoutAction();
    }, time); // Time in milliseconds. You can adjust the duration as needed.
  };

  // this resets the timer if it exists.
  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  useEffect(() => {
    const listener = () => {
      resetTimer();
      handleLogoutTimer();
    };

    window.addEventListener('mousemove', listener);

    return () => {
      window.removeEventListener('mousemove', listener);
    };
  }, [handleLogoutTimer, resetTimer]);

  const cancelConfirmation = () => {
    dispatch(deletePolicyByCache(withoutTemplate?.policyType));
  };

  const logoutAction = () => {
    appService.logout();
    dispatch(toggleReset());
    navigate('/');
    cancelConfirmation();
    window.location.reload();
  };

  return children;
};

export default AppLogout;
